import moment from "moment";
import Typography from "../../../../../../common/Typography";

const ProfileDetails = ({ profileData }) => {
  const profileDetails = [
    [
      {
        label: "Phone Number",
        value: profileData?.phone,
      },
      {
        label: "Gender",
        value: profileData?.gender,
      },
    ],
    [
      {
        label: "Birthday",
        value: profileData?.birthday && moment(profileData?.birthday).format("DD-MM-YYYY"),
      },
      {
        label: "Anniversary",
        value: profileData?.anniversary && moment(profileData?.anniversary).format("DD-MM-YYYY"),
      },
    ],
    [
      {
        label: "Address",
        value: profileData?.address,
      },
    ],
  ];

  return (
    <div className="profile-details">
      <Typography tag="h4" weight="medium" size="display-md">
        Here are your details
      </Typography>
      <Typography customClass="profile-dets-description" size="text-md">
        If this information is not correct, send us an email at{" "}
        <span>support@reelo.io</span>
      </Typography>
      <div className="profile-card">
        <div className="profile-row">
          <div className="profile-col">
            <Typography size="display-md">{profileData?.name}</Typography>
            <Typography customClass="col-label" size="text-md">
              {profileData?.email}
            </Typography>
          </div>
        </div>
        {profileDetails?.map((profileRow, i) => {
          return (
            <div key={i} className="profile-row">
              {profileRow?.map((profileCol, j) => (
                <div key={j} className="profile-col">
                  <Typography customClass="col-val" size="text-md">
                    {profileCol?.value || "--"}
                  </Typography>
                  <Typography customClass="col-label" size="text-sm">
                    {profileCol?.label}
                  </Typography>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileDetails;
